/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Modal } from '@blend/enterprise-components';

import { ModalContent } from 'blb-components/ModalContent';

import { ActionButton } from '@blend/enterprise-components';

export namespace DeleteDocumentModal {
  export interface Props {
    deleteDoc: () => void;
    handleClose: () => void;
    isOpen: boolean;
    title: string;
  }
}
export const DeleteDocumentModal: React.FC<DeleteDocumentModal.Props> = ({ isOpen, deleteDoc, handleClose, title }) => {
  return (
    <Modal contentLabel={title} handleClose={handleClose} isOpen={isOpen}>
      <ModalContent handleClose={handleClose} headerText={title}>
        <div>
          <ActionButton id="it-Delete-Yes" label="Delete" onClick={deleteDoc} theme="primary" />
        </div>
      </ModalContent>
    </Modal>
  );
};

DeleteDocumentModal.displayName = 'DeleteDocumentModal';
